"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Part = void 0;
class Part {
    constructor(sections) {
        this.sections = sections;
    }
    get sort() {
        const section = this.sections[0];
        if (section !== undefined) {
            return section.sort;
        }
        else {
            return null;
        }
    }
}
exports.Part = Part;
